// extracted by mini-css-extract-plugin
export default {"lds-spinner":"style_lds-spinner__VU3Rk","div-after":"style_div-after__53F0n"};